import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-link-button',
  template: `
    <p>
      link-button works!
    </p>
  `,
  styles: [
  ],
})
export class LinkButtonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
